<!-- src/components/EntrancePunjabi.vue -->
<template>
  <div v-if="loading" class="loading-container">
    <div class="spinner"></div>
  </div>
  <h1 class="display-3 text-dark shadow">{{ time }}</h1>
  <div class="table-responsive shadow-lg rounded">
    <table class="table table-striped table-bordered" style="opacity: 0.92">
      <thead class="thead-light table-primary gurmukhi" style="--bs-table-bg: #ffc107">
        <tr>
          <td style="width: 20%">ਤਾਰੀਖ</td>
          <td style="width: 10%">ਸਮਾਂ</td>
          <td style="width: 20%">ਕਮਰਾ</td>
          <td style="width: 20%">ਪ੍ਰੋਗਰਾਮ</td>
          <td style="width: 30%">ਵੇਰਵੇ*</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id" style="vertical-align: middle">
          <td style="height: 100px; vertical-align: middle" class="fs-2">
            {{ translateDateToPunjabi(formatDate(item.date)) }}
          </td>
          <td style="vertical-align: middle" class="fs-2">{{ item.time }}</td>
          <td style="vertical-align: middle" class="fs-1">
            {{ translateRoomToPunjabi(item.roomName.trim()) }}
          </td>
          <td style="vertical-align: middle" class="fs-1">
            {{ translateEventToPunjabi(item.eventType.trim()) }}
          </td>
          <td style="vertical-align: middle" class="fs-1">
            <p class="fs-1">
              {{
                item.titlePunjabi && item.titlePunjabi.trim() !== ""
                  ? item.titlePunjabi.trim()
                  : item.title.trim()
              }}
            </p>
          </td>
        </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="5">
          <span class="last-updated-footer">v{{ version }} | last updated: {{ lastUpdated }}</span>
        </td>
      </tr>
      </tfoot>
    </table>
    <footer>* LLM translations may not be accurate</footer>
  </div>
</template>

<script>
import { getJsonContent } from "../data/getJsonContent.js";
import packageJson from "../../package.json";
import { format } from "date-fns";

export default {
  name: "EntrancePage",
  data() {
    return {
      items: [],
      lastUpdated: ".",
      time: "",
      loading: false,
      reloadInterval: null,
      backgroundImage: "",
      format,
      version: packageJson.version
    };
  },
  mounted() {
    this.fetchData();
    const asthaan = this.$route.query.asthaan;

    // Set up interval to change to English page every n seconds
    this.reloadInterval = setInterval(() => {
      location.href = `/entranceEnglish?asthaan=${asthaan}`;
    }, 1000 * 40);

    setInterval(() => {
      this.time = this.returnTime();
    }, 1000);

    // get random background image
    const imageCount = 27;
    const randomIndex = Math.floor(Math.random() * imageCount);
    this.backgroundImage =
      randomIndex < 10 ? `0${randomIndex}` : randomIndex.toString();
  },
  beforeUnmount() {
    // Clear the interval when the component is destroyed
    clearInterval(this.reloadInterval);
  },
  methods: {
    fetchData() {
      this.loading = true;
      const asthaan = this.$route.query.asthaan;
      console.log("Fetching data for asthaan:", asthaan);
      getJsonContent(asthaan)
        .then((data) => {
          this.items = data.events;
          this.lastUpdated = data?.lastUpdated || ".";
        })
        .catch((error) => {
          console.error("Error fetching JSON content:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(incomingDate) {
      const date = new Date(incomingDate);

      if (Number.isNaN(date.getTime())) {
        console.error("Invalid date format:", incomingDate);
        return "";
      }
      return format(date, "E d MMM");
    },
    translateDateToPunjabi(incomingDate) {
      const punjabiDays = {
        Sun: "ਐਤਵਾਰ",
        Mon: "ਸੋਮਵਾਰ",
        Tue: "ਮੰਗਲਵਾਰ",
        Wed: "ਬੁੱਧਵਾਰ",
        Thu: "ਵੀਰਵਾਰ",
        Fri: "ਸ਼ੁੱਕਰਵਾਰ",
        Sat: "ਸ਼ਨੀਚਰਵਾਰ"
      };

      const punjabiMonths = {
        Jan: "ਜਨਵਰੀ",
        Feb: "ਫ਼ਰਵਰੀ",
        Mar: "ਮਾਰਚ",
        Apr: "ਅਪ੍ਰੈਲ",
        May: "ਮਈ",
        Jun: "ਜੂਨ",
        Jul: "ਜੁਲਾਈ",
        Aug: "ਅਗਸਤ",
        Sep: "ਸਤੰਬਰ",
        Oct: "ਅਕਤੂਬਰ",
        Nov: "ਨਵੰਬਰ",
        Dec: "ਦਸੰਬਰ"
      };

      const [day, date, month] = incomingDate.split(" ");
      const translatedDay = punjabiDays[day] || day;
      const translatedMonth = punjabiMonths[month] || month;
      return `${translatedDay}, ${date} ${translatedMonth}`;
    },
    translateRoomToPunjabi(roomName) {
      const punjabiRoomNames = {
        "Darbar Sahib 1": "ਦਰਬਾਰ ਸਾਹਿਬ ੧",
        "Darbar Sahib 2": "ਦਰਬਾਰ ਸਾਹਿਬ ੨",
        "Darbar Sahib 3": "ਦਰਬਾਰ ਸਾਹਿਬ ੩",
        "Outside Hall": "ਬਾਹਰਲਾ ਹਾਲ",
        "Langar Hall": "ਲੰਗਰ ਹਾਲ",
        "Langar Hall 1": "ਲੰਗਰ ਹਾਲ ੧",
        "Langar Hall 2": "ਲੰਗਰ ਹਾਲ ੨",
        "Main hall": "ਮੁੱਖ ਹਾਲ",
        "Upper hall": "ਉਪਰਲਾ ਹਾਲ",
        "Hall 1": "ਹਾਲ ੧",
        "Hall 2": "ਹਾਲ ੨",
        "Hall 3": "ਹਾਲ ੩",
        "Hall 4": "ਹਾਲ ੪",
        Library: "ਲਾਇਬਰੇਰੀ",
        Kitchen: "ਰਸੋਈ",
        Office: "ਦਫਤਰ",
        Gym: "ਜਿਮ",
        Classroom: "ਕਲਾਸਰੂਮ",
        "Conference Room": "ਕਾਨਫਰੰਸ ਰੂਮ",
        "Storage Room": "ਸਟੋਰੇਜ ਰੂਮ",
        Other: "ਹੋਰ"
      };
      return punjabiRoomNames[roomName] || roomName;
    },
    translateEventToPunjabi(eventType = "") {
      const punjabiEventType = {
        "Siri Sukhmani Sahib Paath": "ਸ਼੍ਰੀ ਸੁਖਮਨੀ ਸਾਹਿਬ ਪਾਠ",
        "Arambh Sri Akhand Paath": "ਅਰੰਭ ਸ਼੍ਰੀ ਅਖੰਡ ਪਾਠ",
        "Bhog Sri Akhand Paath": "ਭੋਗ ਸ਼੍ਰੀ ਅਖੰਡ ਪਾਠ",
        "Bhog Sri Sehj Paath": "ਭੋਗ ਸ਼੍ਰੀ ਸਹਿਜ ਪਾਠ",
        "Anand Karaj": "ਆਨੰਦ ਕਾਰਜ",
        "Asa Di Vaar": "ਆਸਾ ਕੀ ਵਾਰ",
        Funeral: "ਅੰਤਿਮ ਸੰਸਕਾਰ",
        "Gurbani Class": "ਗੁਰਬਾਣੀ ਕਲਾਸ",
        "Keertan Darbaar": "ਕੀਰਤਨ ਦਰਬਾਰ",
        Other: "ਹੋਰ"
      };
      return punjabiEventType[eventType] || eventType;
    },
    getPunjabiTitle(title) {
      return title;
    },
    returnTime() {
      const today = new Date();

      // get time components
      const hours = today.getHours();
      const minutes = today.getMinutes();
      const seconds = today.getSeconds();

      //add '0' to hour, minute & second when they are less 10
      const hour = hours < 10 ? `0${hours}` : hours;
      const minute = minutes < 10 ? `0${minutes}` : minutes;
      const second = seconds < 10 ? `0${seconds}` : seconds;

      //make clock a 12-hour time clock
      const hourTime = hour > 12 ? hour - 12 : hour;

      // if (hour === 0) {
      //   hour = 12;
      // }
      //assigning 'am' or 'pm' to indicate time of the day
      const ampm = hour < 12 ? "AM" : "PM";

      //get current date and time
      const date = format(new Date(), "eeee, do MMMM");
      const time = `${hourTime}:${minute}:${second} ${ampm}`;

      //combine current date and time
      const dateTime = `${date} - ${time}`;
      return dateTime;
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: "gurmukhiFont"; /* The name you’ll use in CSS */
  src: url("@/assets/akaash-elegant-medium.ttf") format("truetype"); /* Path to the TTF */
  font-weight: normal; /* Optional: specify weight */
  font-style: normal; /* Optional: specify style */
}

.gurmukhi {
  font-family: "gurmukhiFont";
}
/* Assign grid areas */
.content {
  grid-area: content;
}

/* Add your styles here */
table {
  width: 100%;
  font-size: xx-large;
  border-collapse: collapse;
}

thead {
  font-size: xx-large;
  text-align: center;
  color: red;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f4f4f4;
  text-align: left;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Adjust as needed */
}

.spinner {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
